import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { CognitoService } from '../cognito.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private excludedUrls = [`${environment.cognitoDomain}/oauth2/token`];

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
/*     return from(this.authService.getSession()).pipe(
      switchMap((session) => {

        let jwttoken = request.clone({
     
          headers: request.headers.set('Authorization', session.idToken.jwtToken),
        });
        return next.handle(jwttoken);
      })
    ); */

    if (this.excludedUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    const token = localStorage.getItem('id_token');

    if (token) {
      const clonedRequest = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
